import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthCoverBgLockScreen() {
	return <AuthShell variant="cover-bg"><AuthForm variant="cover-bg" mode="lock-screen" /></AuthShell>;
}

export default AuthCoverBgLockScreen;
